'use strict';

module.exports = /[^\d.-]/;